import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import Table from "../../components/Table";

import messages from "./messages";

import BulletCanvas from "./BulletCanvas";

const defaultColumns = [
  {
    dataKey: "username",
    labelMessage: messages.reportsLabelUsername,
    minWidth: 200,
  },
];

function getColor(value){
  if (value === 'canceled') {
    return '#d52020'
  } else if (typeof value === 'boolean'){
    return value ? 'green': '#ffeb00'
  }
  return '#1565C0'
}

function createColumns(data, intl) {
  if (!data || !data[0]) return [];
  
  if(data[0].questions) {
    const dynamicColumns = data[0].questions.map((_, questionIndex) => ({
      cellRenderer: ({ row }) => {
        const value = row.questions[questionIndex];
        return <BulletCanvas color={getColor(value)} />;
      },
      label: questionIndex + 1,
    }));
    const fixedColumns = defaultColumns.map(column => ({
      ...column,
      label: intl.formatMessage(column.labelMessage),
    }));
    return fixedColumns.concat(dynamicColumns);
  }
}

class DetailsResultsHitByUserAwnserTable extends React.PureComponent {
  state = {
    columns: [],
    rows: [],
  };
  static getDerivedStateFromProps(props, state) {
    if (state.data !== props.data) {
      return {
        data: props.data,
        columns: createColumns(props.data, props.intl),
        rows: props.data.slice(),
      };
    }
    return null;
  }
  render() {
    const rowsLegend = [
      {label: this.props.intl.formatMessage(messages.legendLabelQuestionHit), type: 'hit'}, 
      {label: this.props.intl.formatMessage(messages.legendLabelQuestionError), type: 'error'},
      {label: this.props.intl.formatMessage(messages.legendLabelOmittedQuestion), type: 'ommited'},
      {label: this.props.intl.formatMessage(messages.legendLabelCanceledQuestion), type: 'canceled'}
    ]
    const columnsLegend = [
      {
      label: '',
      dataKey: 'label'
    }, {
      label: '',
      cellRenderer({row}){
        switch (row.type){
          case 'hit': return <BulletCanvas color="green"/>
          case 'error': return <BulletCanvas color="#1565C0"/>
          case 'canceled': return <BulletCanvas color="#d52020"/>
          default: return <BulletCanvas color="#ffeb00"/>
        }
      }
    }]
    return (
      <div style={{ overflow: "auto" }}>
        <Table {...this.state} />
        <div className="mt-4">
            <Table columns={columnsLegend} rows={rowsLegend} nohead/>
        </div>
      </div>
    );
  }
}
export default injectIntl(React.memo(DetailsResultsHitByUserAwnserTable));
